/**
 * The one canonical origin for this site.
 *
 * Why this exists: the origin was derived independently in 20+ files, half of
 * them hard-coding the apex (zimestates.co.zw) and half the www host, and a few
 * interpolating `${process.env.NEXT_PUBLIC_APP_URL}` with NO fallback at all —
 * which yields the literal string "undefined/..." in any environment where the
 * var is unset (Paynow's IPN callback was one of those).
 *
 * NEXT_PUBLIC_APP_URL IS set in production today, so this is consistency and
 * robustness for new environments rather than a live break.
 *
 * The fallback deliberately matches what production is configured with, so
 * behaviour is unchanged if the var is ever cleared. NOTE for the owner: the
 * app serves from www and the apex 307-redirects to it, so every canonical and
 * sitemap URL currently points at a redirecting host. Reconciling that means
 * changing this env var AND re-registering the redirect URIs with Google,
 * Microsoft and Paynow — an infra change, not a code change.
 */
const FALLBACK = "https://zimestates.co.zw"

function resolve(): string {
  const raw = (process.env.NEXT_PUBLIC_APP_URL ?? "").trim()
  const base = raw.length > 0 ? raw : FALLBACK
  return base.replace(/\/+$/, "")
}

export const SITE_URL = resolve()

/** Absolute URL for a site-relative path. */
export function siteUrl(path = "/"): string {
  return SITE_URL + (path.startsWith("/") ? path : "/" + path)
}
